import React, { Children, useContext } from "react";
import PropTypes from "prop-types";
import ColumnHidingContext from "./ColumnHiding/Context";

/** Represents a group of one or more columns in a table. */
import { jsx as _jsx } from "react/jsx-runtime";
export default function ColGroup(_ref) {
  let {
    id,
    children,
    noSorting,
    ...props
  } = _ref;
  /**
   * Including this do-nothing expression is one way of avoiding the eslint
   * "no-unused-vars" while still pulling it out of `props`.
   */
  noSorting;

  // Add `hidden` attribute if the column group should be hidden.
  // This is because the Table styling is based on the [hidden] attributes
  const {
    hiddenColumns
  } = useContext(ColumnHidingContext);
  const hidden = hiddenColumns.includes(id) || Children.count(children) > 0 && Children.toArray(children).every(child => hiddenColumns.includes(child.props.id));
  return /*#__PURE__*/_jsx("colgroup", {
    hidden: hidden,
    id: id,
    ...props,
    children: children
  });
}
ColGroup.propTypes = {
  /** Zero or more `<Col>` elements. */
  children: PropTypes.node,
  /** A unique identifier for the column group. This is required if there are no `children` and a `<ColumnHiding>` anscestor is present. It also renders as the `id` attribute, so it must be unique on the page. */
  id: PropTypes.string,
  /** When used with a `<Sorting>` ancestor, this column group will not be sortable. */
  noSorting: PropTypes.bool
};